import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function DeleteDesignationModal({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center p-4">
        <h5 className="mb-3">Are you sure?</h5>
        <p className="text-muted">You want to delete this record</p>

        <div className="d-flex justify-content-center gap-2 mt-3">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger">Delete</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}